import { merge } from 'lodash';
import type { DeepPartial } from 'redux';

import { type Brand, UILayout } from '@swf/core/enums';
import type { ModelConfig, RootState, Slicer } from '@swf/core/store';
import type { LocalSettingsState } from '@swf/core/types/localSettings';

export interface LocalSettingsModel extends ModelConfig<LocalSettingsState> {
  reducers: typeof reducers;
  selectors: typeof selectors;
}

const defaultState: LocalSettingsState = {
  documentsSubmitted: false,
  layoutMode: UILayout.Table,
  showBalance: true,
  homegames: { gameTileView: {}, toastMessage: {} },
  poker: {
    spinAndGo: {
      onboardingFinished: false,
      onboardingModalShown: false
    }
  }
};

const reducers = {
  'persist/REHYDRATE': (state: LocalSettingsState, { localSettings }: Partial<RootState> = {}) => ({
    ...state,
    ...localSettings
  }),
  set: (state: LocalSettingsState, payload: DeepPartial<LocalSettingsState> = {}) =>
    merge({}, state, payload)
};

const selectors = (slice: Slicer<LocalSettingsState>) => ({
  get() {
    return slice((state) => state || {});
  },
  getRegistrationBrand() {
    return slice((state) => state.registrationBrand as Brand);
  }
});

const localSettings: LocalSettingsModel = {
  state: defaultState,
  reducers,
  selectors
};

export default localSettings;
